export { default as ColorModeScript } from './color-mode-script';
